export default __webpack_public_path__ + "static/media/bg-mobile.bb7ca168.jpg";